import { z } from 'zod';

export enum TransitionType {
  SINGLE = 'SINGLE',
  BATCH = 'BATCH',
}

export const TransitionTypeLabels: Record<TransitionType, string> = {
  [TransitionType.SINGLE]: 'Individual',
  [TransitionType.BATCH]: 'Por Lotes',
};

export interface TransitionApi {
  id: string;
  name: string;
  toStatusId: string;
  flowId: string;
  type: TransitionType;
  includeAll: boolean;
  isPickup?: boolean;
  excludedCount: number;
  includedCount: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface Transition {
  id: string;
  name: string;
  toStatusId: string;
  flowId: string;
  type: TransitionType;
  includeAll: boolean;
  isPickup?: boolean;
  excludedCount: number;
  includedCount: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface NewTransition {
  name: string;
  toStatusId: string;
  flowId: string;
  type: TransitionType;
  includeAll?: boolean;
  isPickup?: boolean;
}

export interface UpdateTransition {
  id: string;
  name: string;
  toStatusId: string;
  flowId: string;
  type: TransitionType;
  includeAll: boolean;
  isPickup?: boolean;
}

export interface TransitionFilters {
  flowId?: string;
  logisticOperatorId?: string;
}

export const transitionSchema = z.object({
  name: z.string().min(1, 'El nombre es requerido'),
  toStatusId: z
    .string()
    .uuid('El ID del estado destino debe ser un UUID válido'),
  flowId: z.string().uuid('El ID del flujo debe ser un UUID válido'),
  type: z.nativeEnum(TransitionType, {
    errorMap: () => ({ message: 'El tipo debe ser SINGLE o BATCH' }),
  }),
  includeAll: z.boolean().default(false),
  isPickup: z.boolean().default(false),
});

export const updateTransitionSchema = transitionSchema.extend({
  id: z.string().uuid('El ID debe ser un UUID válido'),
});

export type TransitionSchema = z.infer<typeof transitionSchema>;
export type UpdateTransitionSchema = z.infer<typeof updateTransitionSchema>;

export const defaultTransitionValues: TransitionSchema = {
  name: '',
  toStatusId: '',
  flowId: '',
  type: TransitionType.SINGLE,
  includeAll: false,
  isPickup: false,
};

export interface TransitionFormData extends TransitionSchema {
  includedStatusIds: string[];
  excludedStatusIds: string[];
}
